var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cup_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.125 13.75V15.5",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.95801 18.3335H14.2913V17.5002C14.2913 16.5835 13.5413 15.8335 12.6247 15.8335H7.62467C6.70801 15.8335 5.95801 16.5835 5.95801 17.5002V18.3335V18.3335Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.125 18.3333H15.125",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.0003 13.3332C6.77533 13.3332 4.16699 10.7248 4.16699 7.49984V4.99984C4.16699 3.15817 5.65866 1.6665 7.50033 1.6665H12.5003C14.342 1.6665 15.8337 3.15817 15.8337 4.99984V7.49984C15.8337 10.7248 13.2253 13.3332 10.0003 13.3332Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.55853 9.70833C3.93353 9.50833 3.38353 9.14167 2.9502 8.70833C2.2002 7.875 1.7002 6.875 1.7002 5.70833C1.7002 4.54167 2.61686 3.625 3.78353 3.625H4.3252C4.15853 4.00833 4.0752 4.43333 4.0752 4.875V7.375C4.0752 8.20833 4.2502 8.99167 4.55853 9.70833Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4414 9.70833C16.0664 9.50833 16.6164 9.14167 17.0497 8.70833C17.7997 7.875 18.2997 6.875 18.2997 5.70833C18.2997 4.54167 17.3831 3.625 16.2164 3.625H15.6747C15.8414 4.00833 15.9247 4.43333 15.9247 4.875V7.375C15.9247 8.20833 15.7497 8.99167 15.4414 9.70833Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/Rewards-icon.ba09a910f28146b3e46ae0bd01c33148.svg";
export { ForwardRef as ReactComponent };